import React from 'react';
import { WifiOff, RefreshCw } from 'lucide-react';

const PosV2OfflineBanner = ({ online, pending, syncing, onRetry }) => {
  if (online && !pending) return null;
  return (
    <div className="bg-amber-950/90 border-b border-amber-500/40 px-4 py-2 flex flex-wrap items-center gap-3 text-sm text-amber-100">
      <WifiOff size={16} />
      {!online && <span>Mode hors ligne — ventes en file d&apos;attente (Espèces uniquement)</span>}
      {online && pending > 0 && (
        <span className="flex items-center gap-2">
          {syncing ? <RefreshCw size={14} className="animate-spin" /> : null}
          {pending} vente(s) en attente de sync
        </span>
      )}
      {pending > 0 && (
        <button type="button" onClick={onRetry} className="underline font-semibold text-xs">
          Sync maintenant
        </button>
      )}
    </div>
  );
};

export default PosV2OfflineBanner;
